import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FormatCurrencyService {
  public getCurrencySymbol(currency: string): string {
    const currencyCodes: { [k: string]: string } = {
      BRL: 'R$',
      GBP: '£',
      EUR: '€',
      CAD: 'C$',
      MXN: '$',
      AUD: 'A$',
      COP: '$',
      USD: '$',
      NZD: 'NZ$',
      JPY: '¥',
      CHF: 'CHF',
      KRW: '₩',
      SAR: '(SAR) ر.س',
      TRY: '₺',
    };

    return currencyCodes[currency] || '$';
  }

  public formatAmount(amount: number, currency: string): string {
    const symbol = this.getCurrencySymbol(currency);
    const intlAmount = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
    }).format(amount);
    const formattedAmount = this.formatThousandsAndDecimals(
      intlAmount,
      currency,
    );

    return `${symbol} ${formattedAmount} ${currency}`;
  }

  /**
   * @dev This method assumes that the currency decimal length will always be 2
   * digits
   */
  private formatThousandsAndDecimals(
    formattedAmount: string,
    currency: string,
  ): string {
    const separators: { [k: string]: any } = {
      BRL: { thousand: '.', decimal: ',' },
      COP: { thousand: '.', decimal: ',' },
      EUR: { thousand: '.', decimal: ',' },
    };

    if (!separators[currency]) return formattedAmount;

    const currencySeparators: { thousand: string; decimal: string } =
      separators[currency];

    const formattedArray = formattedAmount
      .replace('.', '')
      .replace(/,/g, currencySeparators.thousand)
      .split('');

    formattedArray.splice(
      formattedArray.length - 2, // Assuming the currency decimals is 2 digits
      0,
      currencySeparators.decimal,
    );

    if (currency === 'COP') {
      // Removing decimals only for Colombia Pesos
      formattedArray.splice(formattedArray.length - 3, 3);
    }

    return formattedArray.join('');
  }
}
